import { recentListingStatus } from '../_config';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        listingStatus: [], // listing status  the list 
        listing: [], // listing  listings 
        //  real estate recent listing The state the module is in 
        fetchListingStatus: recentListingStatus.coming,
        currentListingStatus: '', //  currently selected listingStatus
        currentListingStatusName: '', //  currently selected listingStatus of name value ， for display 
        searchParams: {}, // search condition
        hasLocation: false,
        //  pagination parameters 
        totalPage: 0,
        pageSize: 5,
        pageNum: 1,
        showListingPrice: true, //  Do you need to display listing price
        // showSoldPrice: true,   Do you need to display sold listing price
        soldListingInfo: null //  Sold listing information 
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
